import React from 'react';

export const updateLiveAgentStatus = (isLoaded = false) => {
    return {
        type: 'UPDATE_LIVE_AGENT_STATUS',
        isLoaded: isLoaded
    }
};
